import {lazy} from 'react';

const AppointmentRequest = lazy(() => import('./AppointmentRequest'));

export default AppointmentRequest;
